import { SVGProps, Ref, forwardRef } from 'react';

export const CrossCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1M8.636 16.636 12 13.273l3.364 3.363 1.272-1.272L13.273 12l3.363-3.364-1.272-1.272L12 10.727 8.636 7.364 7.364 8.636 10.727 12l-3.363 3.364z"
            fill="currentColor"
        />
    </svg>
));
CrossCircleFilledSize24Glyph.displayName = 'CrossCircleFilledSize24Glyph';
